<script>
/**
 * Todo: diff locales
 */
const formatter = new Intl.NumberFormat(
  'pt-br',
  {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
  },
);

export default {
  props: {
    value: {
      type: [
        String, Number,
      ],
      required: true,
    },

    installments: {
      type: Object,
      required: false,
      default: null,
    },

    price: {
      type: Number,
      required: true,
    },
  },

  data: () => ({
    show: false,
  }),

  computed: {
    options () {
      const {
        installments,
      } = this.installments;

      return installments.map(({ fee_value, installment_value, installment }) =>
        this.getOption(installment, installment_value, fee_value)
      );
    },

    selected () {
      return this.options.find(({ value }) => value === this.value);
    },
  },

  methods: {
    input (value) {
      this.show = false;
      this.$emit('input', value);
    },

    getOption (installment, installment_value, fee_value = 0) {
      const suffix = fee_value > 0 ? '(com juros)' : '(sem juros)';

      return {
        value: installment,
        label: `${installment} x de ${formatter.format(installment_value)} ${suffix}`,
      };
    },
  },
};
</script>

<template>
  <div
    tabindex="0"
    class="bdk-relative"
    @focusout="show = false"
  >
    <label
      v-text="__('Opções de Parcelamento')"
      class="bdk-block bdk-text-sm bdk-font-medium bdk-text-gray-700 bdk-text-left"
    />

    <div
      class="bdk-mt-1 bdk-relative"
    >
      <div
        class="bdk-relative bdk-w-full bdk-bg-white bdk-border bdk-border-gray-300 bdk-rounded-md bdk-shadow-sm bdk-pl-3 bdk-pr-10 bdk-py-2 bdk-text-left bdk-cursor-default focus:bdk-outline-none focus:bdk-ring-1 focus:bdk-ring-indigo-500 focus:bdk-border-indigo-500 sm:bdk-text-sm"
      >
        <div
          @click.prevent="show = ! show"
          class="bdk-flex bdk-items-center bdk-cursor-pointer"
        >
          <span
            class="bdk-bg-green-400 bdk-flex-shrink-0 bdk-inline-block bdk-h-2 bdk-w-2 bdk-rounded-full"
          />

          <span
            v-text="selected.label"
            class="bdk-ml-3 bdk-block bdk-truncate"
          />
        </div>

        <span
          class="bdk-absolute bdk-inset-y-0 bdk-right-0 bdk-flex bdk-items-center bdk-pr-2 bdk-pointer-events-none"
        >
          <!-- <SelectorIcon class="h-5 w-5 text-gray-400" aria-hidden="true" /> -->
        </span>
      </div>

      <div
        v-if="show"
        class="bdk-absolute bdk-z-10 bdk-mt-1 bdk-w-full bdk-bg-white bdk-shadow-lg bdk-max-h-60 bdk-rounded-md bdk-py-1 bdk-text-base bdk-ring-1 bdk-ring-black bdk-ring-opacity-5 bdk-overflow-auto focus:bdk-outline-none sm:bdk-text-sm"
      >
        <div
          @click.prevent="input(index + 1)"
          v-for="({ label, value }, index) of options" :key="index"
          class="bdk-cursor-default bdk-select-none bdk-relative bdk-py-2 bdk-pl-3 bdk-pr-9 bdk-cursor-pointer hover:bdk-text-white hover:bdk-bg-indigo-600"
        >
          <div
            class="bdk-flex bdk-items-center bdk-cursor-pointer"
          >
            <span
              class="bdk-bg-green-400 bdk-flex-shrink-0 bdk-inline-block bdk-h-2 bdk-w-2 bdk-rounded-full"
            />

            <span
              :class="[selected.value === value ? 'bdk-font-semibold' : 'bdk-font-normal', 'bdk-ml-3 bdk-truncate bdk-flex-grow bdk-flex bdk-justify-between']"
            >
              <span
                v-text="label"
                class="bdk-block"
              />
            </span>
          </div>

          <span
            v-if="selected.value === value" :class="[selected === '2' ? 'bdk-text-white' : 'bdk-text-indigo-600', 'bdk-absolute inset-y-0 right-0 flex items-center pr-4']"
          >
            <!-- <CheckIcon class="h-5 w-5" aria-hidden="true" /> -->
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

